import { Icon } from "@/components/Icon";
import { useClickAway } from "@/hooks/useClickAway";
import classNames from "classnames";
import arrowDownIcon from "@/public/icons/arrow-down.svg";
import arrowUpIcon from "@/public/icons/arrow-up.svg";
import { useState } from "react";

export const CatalogControl = ({
  labels,
  selectedIndex = 0,
  onChange,
}: {
  labels: Array<string>;
  selectedIndex?: number;
  onChange?: (selectedIndex: number) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOnChange = (index: number) => {
    setIsOpen(false);
    onChange?.(index);
  };

  const ref = useClickAway<HTMLDivElement>(() => {
    setIsOpen(false);
  });

  return (
    <div ref={ref} className="select-none cursor-pointer sm:h-10">
      <div
        className={classNames(
          "grid grid-cols-[1fr,max-content] items-center",
          "gap-2 px-3 py-2 whitespace-nowrap",
          "bg-white border-b-primary border-b-[1px]"
        )}
        onClick={() => setIsOpen(!isOpen)}
      >
        {labels[selectedIndex]}
        <Icon size="22.5px" src={isOpen ? arrowDownIcon : arrowUpIcon} />
      </div>
      <ul
        className={classNames(
          "z-10 relative flex flex-col pr-8 bg-white sm:shadow-lg",
          "overflow-hidden transition-all duration-200 ease-in-out",
          {
            "h-fit py-3 visible": isOpen,
            "h-0 py-0 invisible": !isOpen,
          }
        )}
      >
        {labels.map((label, index) => (
          <li
            key={index}
            onClick={() => handleOnChange(index)}
            className="leading-loose px-3 whitespace-nowrap"
          >
            {label}
          </li>
        ))}
      </ul>
    </div>
  );
};
